import type { FunctionComponent } from "react";
import { HeroContent } from "./HeroContent";
import { HeroContentSkeleton } from "./HeroContentSkeleton.tsx";
import { HeroImage } from "./HeroImage";
import { usePartnerMarketingModelValue } from "./partnerMarketingModelAtom.ts";

export const HeroSection: FunctionComponent = () => {
    const atom = usePartnerMarketingModelValue();

    return (
        <div className="hero">
            {atom === undefined ? <HeroContentSkeleton /> : <HeroContent />}
            <HeroImage />
        </div>
    );
};
